import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-36 right-4 z-[90] bg-background border rounded-lg shadow-lg p-3 flex items-center gap-3 w-56"
}
const _hoisted_2 = { class: "flex-shrink-0 h-8 w-8 rounded bg-primary/10 flex items-center justify-center" }
const _hoisted_3 = { class: "flex items-center gap-1 flex-shrink-0" }

import { useVoiceNotesWidget } from '@/composables/useVoiceNotesWidget'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Mic, Maximize2, X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'VoiceNotesWidget',
  setup(__props) {

const { isOpen, isMinimized, open, restore, close } = useVoiceNotesWidget()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0 scale-75",
      "enter-to-class": "opacity-100 scale-100",
      "leave-from-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-75"
    }, {
      default: _withCtx(() => [
        (!_unref(isOpen) && !_unref(isMinimized))
          ? (_openBlock(), _createBlock(_unref(TooltipProvider), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(Tooltip), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          variant: "default",
                          size: "icon",
                          class: "fixed bottom-36 right-4 z-[80] h-12 w-12 rounded-full shadow-lg",
                          onClick: _unref(open)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Mic), { class: "h-6 w-6" })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TooltipContent), {
                      side: "left",
                      "side-offset": 8
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("p", { class: "text-sm" }, "Notas de Voz", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0 translate-y-4 scale-95",
      "enter-to-class": "opacity-100 translate-y-0 scale-100",
      "leave-from-class": "opacity-100 translate-y-0 scale-100",
      "leave-to-class": "opacity-0 translate-y-4 scale-95"
    }, {
      default: _withCtx(() => [
        (_unref(isMinimized))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(Mic), { class: "h-4 w-4 text-primary" })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-1 min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-medium truncate" }, "Notas de Voz"),
                _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Minimizado")
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "icon",
                  class: "h-7 w-7",
                  onClick: _unref(restore),
                  title: "Restaurar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Maximize2), { class: "h-3.5 w-3.5" })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "icon",
                  class: "h-7 w-7 text-muted-foreground hover:text-destructive",
                  onClick: _unref(close),
                  title: "Cerrar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(X), { class: "h-3.5 w-3.5" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})